export var UserInteractionEvent;
(function (UserInteractionEvent) {
    UserInteractionEvent[UserInteractionEvent["StartQuiz"] = 0] = "StartQuiz";
    UserInteractionEvent[UserInteractionEvent["CompletedQuiz"] = 1] = "CompletedQuiz";
    UserInteractionEvent[UserInteractionEvent["PlanCreated"] = 2] = "PlanCreated";
    UserInteractionEvent[UserInteractionEvent["SelectRegion"] = 3] = "SelectRegion";
    UserInteractionEvent[UserInteractionEvent["SelectSubRegion"] = 4] = "SelectSubRegion";
    UserInteractionEvent[UserInteractionEvent["SelectAge"] = 5] = "SelectAge";
    UserInteractionEvent[UserInteractionEvent["SelectEthnicity"] = 6] = "SelectEthnicity";
    UserInteractionEvent[UserInteractionEvent["WhereHeardAboutDBIU"] = 7] = "WhereHeardAboutDBIU";
    UserInteractionEvent[UserInteractionEvent["RiskLevel"] = 8] = "RiskLevel";
    UserInteractionEvent[UserInteractionEvent["SelectGender"] = 9] = "SelectGender";
    UserInteractionEvent[UserInteractionEvent["DrinkCoach"] = 10] = "DrinkCoach";
    UserInteractionEvent[UserInteractionEvent["ClickedOnlineAppointment"] = 11] = "ClickedOnlineAppointment";
    UserInteractionEvent[UserInteractionEvent["ClickedEnfieldLocalAdvice"] = 12] = "ClickedEnfieldLocalAdvice";
    UserInteractionEvent[UserInteractionEvent["PostCodeEntered"] = 13] = "PostCodeEntered";
    UserInteractionEvent[UserInteractionEvent["DirectedToHub"] = 14] = "DirectedToHub";
    UserInteractionEvent[UserInteractionEvent["LaunchUrl"] = 15] = "LaunchUrl";
    UserInteractionEvent[UserInteractionEvent["LoadSection"] = 16] = "LoadSection";
    UserInteractionEvent[UserInteractionEvent["SelectSexuality"] = 17] = "SelectSexuality";
    UserInteractionEvent[UserInteractionEvent["CallbackRequested"] = 18] = "CallbackRequested";
    UserInteractionEvent[UserInteractionEvent["SelectOrgType"] = 19] = "SelectOrgType";
    UserInteractionEvent[UserInteractionEvent["SelectStaffGroup"] = 20] = "SelectStaffGroup";
})(UserInteractionEvent || (UserInteractionEvent = {}));
export var EventCategory;
(function (EventCategory) {
    EventCategory[EventCategory["FollowUpAction"] = 0] = "FollowUpAction";
    EventCategory[EventCategory["Demographics"] = 1] = "Demographics";
    EventCategory[EventCategory["GoalConversion"] = 2] = "GoalConversion";
    EventCategory[EventCategory["AUDIT"] = 3] = "AUDIT";
    EventCategory[EventCategory["AuditResults"] = 4] = "AuditResults";
    EventCategory[EventCategory["ReferralPath"] = 5] = "ReferralPath";
})(EventCategory || (EventCategory = {}));
//# sourceMappingURL=UserEvents.js.map